import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
  	{ // 重定向
			path: '/',
			redirect: '/index'
		},
		{
			path:'/nav',
			component: resolve => require(['../components/common/Nav'],resolve),
			meta:{
				keepAlive:true,
				requireAuth:true
			  },
			children:[
				{
					path:'/index',
					name:'首页',
					component: resolve => require(['../components/page/Index'],resolve),
					meta:{
						keepAlive:false,
						index:0
					  }
				},
				{
					path:'/about',
					name:'关于富阳',
					redirect:'/about1',
					component: resolve => require(['../components/page/about/About'],resolve),
					children:[
						{
							path:'/about1',
							component: resolve => require(['../components/page/about/fuyangjianjie'],resolve),
							meta:{
								keepAlive:false,
								index:1
							  },
						},
						{
							path:'/about2',
							component: resolve => require(['../components/page/about/fazhanlicheng'],resolve),
							meta:{
								keepAlive:false,
								index:2
							  },
							
						},
						{
							path:'/about3',
							component: resolve => require(['../components/page/about/guanlituandui'],resolve),
							meta:{
								keepAlive:false,
								index:3
							  },
						},
						{
							path:'/about4',
							component: resolve => require(['../components/page/about/fazhanyuanjing'],resolve),
							meta:{
								keepAlive:false,
								index:4
							  },
						}
					]
				},
				{
					path:'/qiye',
					name:'企业管治',
					component: resolve => require(['../components/page/qiye/qiye'],resolve),
					meta:{
						keepAlive:false,
						index:5
					  }
				},
				{
					path:'/yewu',
					name:'业务领域',
					component: resolve => require(['../components/page/yewu/yewu'],resolve),
				
					children:[
						{
							path:'/yewu1',
							component: resolve => require(['../components/page/yewu/jituanjiagou'],resolve),
							meta:{
								keepAlive:false,
								index:6
							  },
						},
						{
							path:'/yewu2',
							component: resolve => require(['../components/page/yewu/jingdiananli'],resolve),
							meta:{
								keepAlive:false,
								index:7
							  },
						},
						{
							path:'/yewu3',
							component: resolve => require(['../components/page/yewu/international'],resolve),
							meta:{
								keepAlive:false,
								index:8
							  },
						}						
					]
				},
/*				{
					path:'/guonei',
					name:'国内个案',
					component: resolve => require(['../components/page/guonei/guonei'],resolve),
					
					children:[
						{
							path:'/guonei1',
							component: resolve => require(['../components/page/guonei/guoneigean'],resolve),meta:{
								keepAlive:false,
								index:8
							  },
						},
						{
							path:'/guonei2',
							component: resolve => require(['../components/page/guonei/daibiaogean'],resolve),
							meta:{
								keepAlive:false,
								index:9
							  },
						}
					]
				},
				{
					path:'/haiwai',
					name:'海外个案',
					component: resolve => require(['../components/page/haiwai/haiwai'],resolve),
					children:[
						{
							path:'/haiwai1',
							component: resolve => require(['../components/page/haiwai/haiwaizhiye'],resolve),
							meta:{
								keepAlive:false,
								index:10
							  },
						
						},
						{
							path:'/haiwai2',
							component: resolve => require(['../components/page/haiwai/zhongjiedian'],resolve),
							meta:{
								keepAlive:false,
								index:11
							  },
						},	
						{
							path:'/haiwai3',
							component: resolve => require(['../components/page/haiwai/yidaiyilu'],resolve),
							meta:{
								keepAlive:false,
								index:12
							  },
						},
						{
							path:'/haiwai4',
							component: resolve => require(['../components/page/haiwai/jianpuzhai'],resolve),
							meta:{
								keepAlive:false,
								index:13
							  },
						},
//						{
//							path:'/haiwai5',
//							component: resolve => require(['../components/page/haiwai/vhouse'],resolve),
//						},
						{
							path:'/ptsProject',
							component: resolve => require(['../components/page/haiwai/ptsProject'],resolve),
							meta:{
								keepAlive:false,
								index:14
							  },
						},
						{
							path:'/jpzCountryIntroduce',
							component: resolve => require(['../components/page/haiwai/jpzCountryIntroduce'],resolve),
							meta:{
								keepAlive:false,
								index:15
							  },
						},
						{
							path:'/plwsProject',
							component: resolve => require(['../components/page/haiwai/plwsProject'],resolve),
							meta:{
								keepAlive:false,
								index:16
							  },
						},
					]
				},  */
				{
					path:'/touzi',
					name:'投资者关系',
					component: resolve => require(['../components/page/touzi/touzi'],resolve),
				
					children:[
						{
							path:'/touzi1',
							component: resolve => require(['../components/page/touzi/caiwubaogao'],resolve),
							meta:{
								keepAlive:false,
								index:17
							  },
						},
						{
							path:'/touzi2',
							component: resolve => require(['../components/page/touzi/jituangonggao'],resolve),
							meta:{
								keepAlive:false,
								index:18
							  },
						}
					]
				},
				{
					path:'/lianxi',
					name:'联系我们',
					component: resolve => require(['../components/page/lianxi'],resolve),
					meta:{
						keepAlive:false,
						index:19
					  },
				}
			]
		}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js